import { GetApiV1ThreeLetterCodeClientAdminsStressAssessments200 } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import { StressAssessmentListPresentation } from '../../presentations';

type Args = {
  data: GetApiV1ThreeLetterCodeClientAdminsStressAssessments200;
};
type ComponentProps = React.ComponentProps<typeof StressAssessmentListPresentation>;

type IConvertToStressAssessmentListProps = (data: Args) => {
  conductedStressAssessments: ComponentProps['conductedStressAssessments'];
};

const convertedStatus = {
  ongoing: '実施中',
  completed: '完了',
} as const;

export const convertToStressAssessmentListProps: IConvertToStressAssessmentListProps = ({
  data,
}) => {
  const conductedStressAssessments = data.stress_assessments.map(sa => ({
    id: sa.id,
    implementationDate: formatDate({
      date: new Date(sa.survey_date * 1000),
      formatType: 'yyyy/M/d',
    }),
    deadline: formatDate({ date: new Date(sa.due_date * 1000), formatType: 'yyyy/M/d' }),
    target: `${sa.completed_count + sa.pending_count}（${sa.total_count}）`,
    completed: `${sa.completed_count}（${Math.round(sa.completed_rate)}%）`,
    notAnswered: `${sa.pending_count}（${Math.round(sa.pending_rate)}%）`,
    highStress: `${sa.high_stress_count}（${Math.round(sa.high_stress_rate)}%）`,
    status: convertedStatus[sa.status],
  }));

  return {
    conductedStressAssessments,
  };
};
